import empty from '../../../empty'

export default function ctx() {
    return empty;
}
